import { useContext, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import '../styles/home.css'
import { config } from '../config'
import { UserContext } from '../contexts'
import Dashboard from '../containers/dashboard'
import UploadDocumentProcess from '../containers/upload-document-process'
import ReportsBriefManagement from '../containers/reports-brief-management'
import BanksBalancesBriefManagement from '../containers/banks-balances-brief-management'
import IndividualMoneyTransfersManagement from '../containers/individual-money-transfers-management'

const Home = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const { userSession } = useContext(UserContext)
  const [displayElements, setDisplayElements] = useState<boolean>(false)

  useEffect(() => {
    if (userSession?.subRole && userSession.subRole === 'paxum-customer-service-specialist') {
      setDisplayElements(false)
      navigate(`/customer-company-payments-history/${userSession.belongsTo}`, { replace: true })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userSession])

  useEffect(() => {
    if (userSession?.subRole && userSession.subRole === 'paxum-customer-service-specialist') {
      setDisplayElements(false)
      return
    }

    setDisplayElements(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  return (
    <Dashboard>
      {displayElements ? (
        <>
          {((config.environment !== 'production' &&
            location.pathname === '/' &&
            (userSession?.role.indexOf('client') === -1 ||
              (userSession?.role.includes('-client') && (String(config.app.paxumCompanyId) === String(userSession?.belongsTo) || String(config.app.demoPaxumCompanyId) === String(userSession?.belongsTo))))) ||
            (config.environment === 'production' &&
              location.pathname === '/' &&
              (userSession?.role.indexOf('client') === -1 || (userSession?.role.includes('-client') && String(config.app.paxumCompanyId) === String(userSession.belongsTo))))) && (
            <>
              <BanksBalancesBriefManagement />
              {((userSession?.role === 'super-admin' || userSession?.role === 'admin') && !userSession.subRole) ||
              (userSession?.role === 'super-admin' && userSession.subRole && userSession.subRole !== 'reconciliation-specialist') ? (
                <div
                  style={{ flexDirection: 'column' }}
                  className="section-container-align-center"
                >
                  <ReportsBriefManagement />
                </div>
              ) : (
                <div className="section-container-align-center">
                  {(!userSession?.subRole || (userSession.subRole && userSession.subRole !== 'reconciliation-specialist' && userSession.subRole !== 'paxum-customer-service-specialist')) && (
                    <>
                      <UploadDocumentProcess />
                      {((config.environment !== 'production' &&
                        (userSession?.role === 'admin' ||
                          (userSession?.role.includes('client') && (String(config.app.paxumCompanyId) === String(userSession?.belongsTo) || String(config.app.demoPaxumCompanyId) === String(userSession?.belongsTo))))) ||
                        (config.environment === 'production' && (userSession?.role === 'admin' || (userSession?.role.includes('-client') && String(config.app.paxumCompanyId) === String(userSession.belongsTo))))) && (
                        <IndividualMoneyTransfersManagement />
                      )}
                    </>
                  )}
                </div>
              )}
            </>
          )}
          {((config.environment !== 'production' &&
            location.pathname === '/' &&
            userSession?.role.includes('-client') &&
            String(config.app.paxumCompanyId) !== String(userSession?.belongsTo) &&
            String(config.app.demoPaxumCompanyId) !== String(userSession?.belongsTo)) ||
            (config.environment === 'production' && location.pathname === '/' && userSession?.role.includes('-client') && String(config.app.paxumCompanyId) !== String(userSession?.belongsTo))) && (
            <div className="client-section-container">
              <div className="client-section-left-container">
                {((config.environment !== 'production' &&
                  (String(config.app.scienciatechCompanyId) === String(userSession?.belongsTo) || String(config.app.demoScienciatechCompanyId) === String(userSession?.belongsTo)) &&
                  (userSession?.role === 'super-admin-client' || userSession?.role === 'admin-client')) ||
                  (config.environment === 'production' &&
                    String(config.app.scienciatechCompanyId) === String(userSession?.belongsTo) &&
                    (userSession?.role === 'super-admin-client' || userSession?.role === 'admin-client'))) && <BanksBalancesBriefManagement />}
                {((config.environment !== 'production' &&
                  String(config.app.scienciatechCompanyId) !== String(userSession?.belongsTo) &&
                  String(config.app.demoScienciatechCompanyId) !== String(userSession?.belongsTo) &&
                  userSession?.role.indexOf('builder') === -1) ||
                  (config.environment === 'production' && String(config.app.scienciatechCompanyId) !== String(userSession?.belongsTo) && userSession?.role.indexOf('builder') === -1)) && <BanksBalancesBriefManagement />}
                <UploadDocumentProcess />
              </div>
              <IndividualMoneyTransfersManagement />
            </div>
          )}
        </>
      ) : (
        <></>
      )}
    </Dashboard>
  )
}

export default Home
